export const getCurrentSection = (url) => {
    let slug = url.pathname.split('/')[2]

    return slug
}